import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { Button, Card, CardContent, Typography } from '@mui/material';
import { AccountCircle, AccountCircleOutlined, Add, SentimentDissatisfiedOutlined } from '@mui/icons-material';
import { useRouter } from 'next/router';

export const ContactosGenerales = (props) => {
  const { contactosCount = 0, user, ...other } = props;
  const router = useRouter();

  return (
    <>
      {
        contactosCount > 0 && (
          <Card {...props}
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              px: 3,
              py: 4
            }}
          >
            <AccountCircle
              sx={{ fontSize: 56 }}
              color="primary"
            />
            <Typography
              color="textSecondary"
              variant="h4"
            >
              {contactosCount}
            </Typography>
            <Typography
              color="textSecondary"
              variant="body2"
              textAlign="center"
            >
              Contactos
            </Typography>
            <Button
              color="primary"
              variant="contained"
              sx={{ mt: 2 }}
              size="small"
              startIcon={<Add />}
              onClick={() => {
                router.push('/dashboard/call-center/nuevo');
              }}
            >
              Añadir contacto
            </Button>

            <NextLink href="/dashboard/call-center">
              <Typography
                color="primary"
                sx={{
                  mt: 2,
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: 1
                }}
                variant="subtitle2"
              >
                Ver todos los contactos
              </Typography>
            </NextLink>

          </Card>
        ) || (
          <Card>
            <CardContent
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                p: 4
              }}
            >
              <AccountCircleOutlined
                sx={{
                  color: 'primary.main',
                  height: 56,
                  width: 56
                }}
              />
              <Typography
                color="textSecondary"
                variant="h6"
                sx={{ mt: 2 }}
              >
                No hay contactos pendientes
              </Typography>
              <Button
                color="primary"
                variant="contained"
                sx={{ mt: 2 }}
                size="small"
                startIcon={<Add />}
                onClick={() => {
                  router.push('/dashboard/call-center/nuevo');
                }}
              >
                Añadir contacto
              </Button>
            </CardContent>
          </Card>
        )
      }
    </>
  );

}

ContactosGenerales.propTypes = {
  contactosCount: PropTypes.number,
  user: PropTypes.object
};